import Fetch from '../utils/fetch';
import { settings } from '../settings';
import { InternalAddress } from '../types/orderTypes';

export async function updateOrdersPickupLocation(
  orderIds: string[],
  pickupAddress: InternalAddress
): Promise<boolean> {
  const response = await Fetch.put({
    url: `${settings.newApiUrl}/order/change-hub-address`,
    body: {
      orderIds: orderIds,
      hubAddress: pickupAddress,
    },
  });
  return response.ok;
}
